import { render, staticRenderFns } from "./FileManagerForm.vue?vue&type=template&id=683d8060&scoped=true&"
import script from "./FileManagerForm.vue?vue&type=script&lang=ts&"
export * from "./FileManagerForm.vue?vue&type=script&lang=ts&"
import style0 from "./FileManagerForm.vue?vue&type=style&index=0&id=683d8060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683d8060",
  null
  
)

export default component.exports